import React from 'react';
import logo from '../../assets/logo.png';

const Logo = () => {
  return <img src={logo} alt="Liga" width={200} />;
};

export default Logo;
